import React from "react";
import { Field, reduxForm, stopSubmit, FieldArray } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../../system/fields/TextInput";
import SelectDropdown from "../../../system/fields/SelectDropdown";
import FileUpload from "../../../system/fields/FileUpload";
import StarRating from "../../../system/fields/StarRating";

import * as validations from "../../../system/utils/Validation";
import DatePickerOld from "../../../system/fields/DatePickerOld";

const planItem = ({ fields }) =>
  fields.map((p, i) => (
    <div className={"row"} key={i}>
      <FormGroup className={"col-12 col-sm-6"}>
        <Label>Destination {i + 1}</Label>
        <Field
          name={`${p}.dest`}
          component={TextInput}
          type={"text"}
          disabled
        />
      </FormGroup>
      <FormGroup className={"col-12 col-sm-6"}>
        <Label>Nights</Label>
        <Field
          name={`${p}.nights`}
          component={TextInput}
          type={"text"}
          disabled
        />
      </FormGroup>
    </div>
  ));

let EditForm = (props, { fields }) => {
  const { handleSubmit, mode } = props;
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Referrer</Label>
              <Field name="ref" component={TextInput} type="text" disabled />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">GCLID</Label>
              <Field name="gclid" component={TextInput} type="text" disabled />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">First Name</Label>
              <Field
                name="enquiry_details.first_name"
                component={TextInput}
                placeholder="First Name"
                type="text"
                disabled
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Last Name</Label>
              <Field
                name="enquiry_details.last_name"
                placeholder="Last Name"
                component={TextInput}
                type="text"
                disabled
              />
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Email Address</Label>
              <Field
                name="enquiry_details.email"
                component={TextInput}
                type="email"
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Phone Number</Label>
              <Field
                name="enquiry_details.phone_number"
                component={TextInput}
                type="phone"
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Departure Date</Label>
              <Field
                name="enquiry_details.date"
                component={DatePickerOld}
                dateFormat={"MMM dd yyyy h:mm a"}
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Travellers</Label>
              <Field
                name="enquiry_details.persons"
                component={TextInput}
                type={"number"}
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Nights</Label>
              <Field
                name="enquiry_details.rooms"
                component={TextInput}
                type={"number"}
                disabled
              />
            </FormGroup>
            <FormGroup className={"col-12"}>
              <Label>Requirements</Label>
              <Field
                name={"enquiry_details.other"}
                className={"w-100"}
                style={{
                  minHeight: 150,
                  maxHeight: 400,
                  height: "auto",
                  overflow: "scroll",
                }}
                component={"textarea"}
                type={"text"}
                disabled
              />
            </FormGroup>
            <FormGroup className={"col-12"}>
              <div className="form-section-header">Enquiry Details</div>
            </FormGroup>
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>Airport</Label>
              <Field
                name={"details.airport"}
                component={TextInput}
                type={"text"}
                disabled
              />
            </FormGroup>
          </div>
          <FieldArray name={"details.plan"} component={planItem} />
        </section>
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />
            Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "TestForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("TestForm"));
    }
  },
})(EditForm);

export default EditForm;



// WEBPACK FOOTER //
// ./src/containers/Enquiries/ItineraryBuilder/Form.jsx